import { Badge, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";

const InGeniusSavingBadge = ({ savingsAmount }: { savingsAmount: string }) => {
  const i18n = useI18n();

  return (
    <Stack direction="row">
      <Text>{i18n.trans(t("flights_fd_campaign_flight_price"))}</Text>
      <Badge
        variant="brand-genius-primary"
        text={i18n.trans(
          t("flights_fd_campaign_saving_amount_badge", {
            variables: {
              currency_price_saving: savingsAmount || 0
            }
          })
        )}
        alternative
      />
    </Stack>
  );
};

export default InGeniusSavingBadge;
